<template>
    <div style="display: inline-block;">
        <Image imageClass="tw-image" :imageStyle="{ 'object-fit': fit, width: width, height: height }" :src="imgSrc" :alt="alt" :preview="preview"/>
    </div>
</template>

<script>
import { computed } from 'vue'
import Image from 'primevue/image';

export default {
    name: 'tw-image',
    components: {
        Image
    },
    setup(props) {
        const imgSrc = computed(() => {
            if (props.data_source && props.field_name) {
                let current
                // 可能是数据源对象，也可能是插槽传过来的对象
                if (props.data_source?.datas && Array.isArray(props.data_source?.datas)) {
                    current = props.data_source?.current ?? props.data_source?.datas[0] ?? {}
                } else {
                    current = props.data_source ?? {}
                }
                return current[props.field_name]
            } else {
                return props.src
            }
        })

        return {
            imgSrc
        }
    },
    props: {
        data_source: {
            type: Object,
            default: function() {
                return { }
            }
        },
        field_name: {
            type: String,
            default: ''
        },
        preview: {
            type: Boolean,
            default: false
        },
        src: String,
        alt: String,
        fit: String,
        width: {
            type: String,
            default: "100px"
        },
        height: {
            type: String,
            default: "auto"
        }
    }
}
</script>